import 'lazysizes'; // for lazy loaded images
import { BaseModule } from './base.module';
// Version for Nexus!
export class LazyLoadModule extends BaseModule {

	constructor() {
		super();
		this._root = document;
	}

	initialize() {
		if (typeof this._root !== 'undefined') {
			this.setEventListeners();
		}
	}

	setEventListeners() {
		this._root.addEventListener('lazybeforeunveil', (event) => {
			this.onLazyBeforeUnveil(event);
		});
		this.handleImagesErrors();
	}

	handleImagesErrors() {
		// console.log('handleImagesErrors', this._root);
		if (typeof this._root !== 'undefined') {
			let images = this._root.querySelectorAll('img');
			images.forEach((image) => {
				image.addEventListener('error', (event) => {
					// if (typeof event.currentTarget !== 'undefined') {
						console.warn('An asset could not be loaded, loading fallback', event.currentTarget);
						let svg = this._root.createElementNS("http://www.w3.org/2000/svg","svg");
						let use = this._root.createElementNS("http://www.w3.org/2000/svg","use");
						let title = this._root.createElementNS("http://www.w3.org/2000/svg", "title");
						title.textContent = 'Een plaatshouder voor een afbeelding';
						use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-logo-missing');
						svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
						svg.setAttribute('height', '320');
						svg.appendChild(title);
						svg.appendChild(use);
						svg.classList.add('icon-logo-missing');
						svg.classList.add('w-100');
						// svg.classList.add('h-100');
						
						event.currentTarget.parentNode.appendChild(svg);
						event.currentTarget.remove(); // does not trigger in IE 11 so no remove() polyfill needed
					// }
				})
			});
		}
	}

	onLazyBeforeUnveil(event) {
		var bg = event.target.getAttribute('data-bg');
		if (bg) {
			event.target.style.backgroundImage = 'url(' + bg + ')';
		}
	}
}